import React, { useState } from "react";
import BusImage from "../assets/images/bus.png";
import Call from "../assets/icons/call.svg";
import Location from "../assets/icons/location.svg";
import Calender from "../assets/icons/calender.svg";

import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import FormInput from "../components/form/formInput/FormInput";
import FormButton from "../components/form/formButton/FormButton";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const onSetDescription = (e: any) => {
    setDescription(e.target.value);
  };
  const { register, formState, handleSubmit } = useForm();
  const onSubmit: SubmitHandler<FieldValues> = (formData) => {};

  return (
    <div>
      <div className="container mx-auto pt-24 md:pt-36 pb-12 px-5 text-black">
        <div className="flex flex-col gap-3 mb-7 md:pl-10">
          <div className="flex items-center text-4xl font-bold head gap-3 ">
            <span>Get</span>
            <span className="text-pry">In Touch</span>
            <div className="h-2 w-4 bg-pry"></div>
          </div>
          <div className="text text-lg md:w-[55%]">
            You can contact us any way that is convenient for you. We are
            available 24/7 email. You can also use a quick contact form below or
            visit our office personally.
          </div>
        </div>
        <img src={BusImage} alt="" className="mb-10" />
        <div className="flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-5 md:px-20   justify-between">
          <div className="flex flex-col items-center md:items-start gap-4">
            <div className="bg-orange10 flex items-center justify-center w-10 h-10 rounded-full">
              <img src={Call} alt="" className="p-3" />
            </div>
            <a href="tel:+234 805 555 5595">+234 805 555 5595</a>
            <a href="tel:+234-802-846-0890">+234-802-846-0890</a>
          </div>
          <div className="flex flex-col items-center md:items-start gap-4">
            <div className="bg-orange10 flex items-center justify-center w-10 h-10 rounded-full">
              <img src={Location} alt="" className="p-3" />
            </div>
            <div className="">345, Muritala Muhammed Way, Lagos Nigeria</div>
          </div>
          <div className="flex flex-col items-center md:items-start gap-4">
            <div className="bg-orange10 flex items-center justify-center w-10 h-10 rounded-full">
              <img src={Calender} alt="" className="p-3" />
            </div>
            <div className="font-semibold">Opening Hours</div>
            <div className="">Mon - Sun: 6:00am-5:00pm</div>
          </div>
        </div>
      </div>
      <div className="bg-particles">
        <div className="container mx-auto flex flex-col items-center py-10 md:py-16 px-5 md:px-10">
          <div className="flex items-center gap-2">
            <div className="text-4xl font-bold head gap-3">
              Send Us A Message
            </div>
            <div className="h-2 w-4 bg-pry"></div>
          </div>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full mt-4 md:mt-8"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5">
              <FormInput
                color="blue"
                formState={formState}
                name="firstname"
                register={register}
                rules={{ required: "Enter first name" }}
                type="text"
                label="First Name"
                placeholder="Enter first name"
              />
              <FormInput
                color="blue"
                formState={formState}
                name="lastname"
                register={register}
                rules={{ required: "Enter last name" }}
                type="text"
                label="Last Name"
                placeholder="Enter last name"
              />
              <FormInput
                color="blue"
                formState={formState}
                name="email"
                register={register}
                rules={{ required: "Enter email" }}
                type="email"
                label="Email"
                placeholder="Enter Email"
              />
              <FormInput
                color="blue"
                formState={formState}
                name="phonenumber"
                register={register}
                rules={{ required: "Enter phone number" }}
                type="tel"
                label="Phone Number"
                placeholder="Enter phone number"
              />
              <div className="flex flex-col mt-3 w-ful">
                <div className="text-base font-semibold head">Message</div>
                <textarea
                  className="p-5  border mt-2 border-[#D2D2D2]  outline-none"
                  name="description"
                  value={description}
                  onChange={onSetDescription}
                  placeholder="Write note here"
                  required
                  rows={4}
                  id=""
                ></textarea>
              </div>
            </div>
            <div className="w-full md:w-[20%]  bg-red-400 mt-2">
              <FormButton
                error={false}
                label="Submit"
                loading={loading}
                small
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
